/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SegmentIdsResponse } from '../../models/segment-ids-response';

export interface GetSegmentsForUser$Params {
  'Active-Tenant-Identifier': string;
  userId: string;
}

export function getSegmentsForUser(http: HttpClient, rootUrl: string, params: GetSegmentsForUser$Params, context?: HttpContext): Observable<StrictHttpResponse<SegmentIdsResponse>> {
  const rb = new RequestBuilder(rootUrl, getSegmentsForUser.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SegmentIdsResponse>;
    })
  );
}

getSegmentsForUser.PATH = '/users/{userId}/segments';
